export enum FormAction{
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  SEARCH = 'SEARCH',
  ERASE = 'ERASE',
  SOFTDELETE = 'SOFTDELETE',
  ROLLBACK = 'ROLLBACK',
}
